// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxGroup_checkbox__a8IBR"};